import { hasClass } from 'src/utils/classNames';
import { cm } from 'src/utils/classNames';
import { WithClassName } from 'src/utils/UtilityTypes';

interface Props extends WithClassName {
	vertical?: boolean;
}

/**
 * Renders a simple horizontal or vertical divider.
 */
export default function Divider({ className, vertical }: Props) {
	const heightClassNames = (() => {
		if (vertical) {
			return !hasClass(className, 'h-') ? 'self-stretch h-auto' : '';
		}

		// use `min-h-px` to prevent shrinking to `0px`.
		return 'h-px min-h-px';
	})();

	return (
		<div
			className={cm(
				'bg-stroke-divider',
				// use `min-w-px` to prevent shrinking to `0px`.
				vertical ? 'w-px min-w-px' : 'w-full',
				heightClassNames,
				className
			)}
		/>
	);
}
